import { render, staticRenderFns } from "./SelectsType.vue?vue&type=template&id=501f7919&scoped=true"
import script from "./SelectsType.vue?vue&type=script&lang=js"
export * from "./SelectsType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501f7919",
  null
  
)

export default component.exports